import { render, staticRenderFns } from "./add_task_type_form.vue?vue&type=template&id=1e2f0b97"
import script from "./add_task_type_form.vue?vue&type=script&lang=js"
export * from "./add_task_type_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports